<template>
  <div>
    <h4 v-if="title" class="grey--text">
      {{ $t(`hausefulInvoices.${title}`) }}
    </h4>

    <div v-for="(client, index) in clients" :key="index">
      <h5 class="subtitle-1 grey--text text--darken-2 pl-1">
        <span class="d-block grey--text font-weight-bold caption mt-4 mb-n1">
          {{ $t('hausefulInvoices.realEstate') }}
        </span>
        {{ client.name }}
      </h5>
      <div class="mb-5">
        <div v-for="(branch, index) in returnBranches(client)" :key="index">
          <div class="no-padding d-flex px-1">
            <v-divider vertical />
            <div class="d-flex align-end pb-4" :style="{ width: '100%' }">
              <div class="pl-5 mr-auto">
                <h6 class="body-2 grey--text text--darken-2">
                  <span class="d-block grey--text font-weight-bold caption mt-2">
                    {{ $t('hausefulInvoices.subsidiary') }}
                  </span>
                  {{ branch.name }}
                </h6>
              </div>
              <div class="text-right mx-3">
                <h5 class="d-block body-2 success--text">
                  <span class="d-block grey--text font-weight-bold caption mt-2">
                    {{ $t('hausefulInvoices.total') }}
                  </span>
                  {{ totalAmount(branch.total) }}
                </h5>
              </div>
              <HCheckbox :input-value="isSelected(branch.payments)" @input="paymentsSelected(branch.payments, $event)" />
            </div>
          </div>
          <v-divider class="ml-1" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HCheckbox from '@/components/app/HCheckbox'

import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'PaymentFortnight',

  props: {
    fortnight: {
      type: Object,
    },

    title: {
      type: String,
    },
    selectedPayments: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    HCheckbox,
  },

  computed: {
    clients() {
      return Object.values(this.fortnight)
    },
  },

  methods: {
    returnBranches(client) {
      return Object.values(client.branches)
    },

    totalAmount(amount) {
      return catalogMonetary(amount ?? 0.00)
    },

    paymentsSelected(payments, checkboxValue) {
      checkboxValue
        ? this.$emit('insertPayments', payments)
        : this.$emit('deletePayments', payments)
    },

    isSelected(payments) {
        return payments.map(it => it.id).every(payment => this.selectedPayments.map(it => it.id).includes(payment));
    },
  }
}
</script>
